import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { CurrentUserService } from '../services/auth/current-user.service';

export const authGuard = (requiredRole?: string | string[]): CanActivateFn => {
	return (_route, state) => {
		const authService = inject(AuthService);
		const currentUserService = inject(CurrentUserService);
		const router = inject(Router);
		const platformId = inject(PLATFORM_ID);

		// In SSR, allow navigation for page rendering
		if (!isPlatformBrowser(platformId)) {
			return true;
		}

		const token = authService.getToken();
		if (!token) {
			// Back to the requested page after logging in
			return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
		}

		// Get role from CurrentUserService (stored during login)
		const userRole = currentUserService.getUserRoleName();

		// If no specific role is required, just verify authentication
		if (!requiredRole) {
			return true;
		}

		// Check if user has any of the required roles
		const hasRequiredRole = Array.isArray(requiredRole)
			? requiredRole.some((role) => role.toLowerCase() === userRole?.toLowerCase())
			: requiredRole.toLowerCase() === userRole?.toLowerCase();

		if (hasRequiredRole) {
			return true;
		}

		// Redirect to boost (all employees go to backoffice)
		router.navigate(['/boost']);

		return false;
	};
};
